import React from 'react'
import { Box, Flex } from 'rebass/styled-components'
import styled from 'styled-components'
import AnimationWrapper from '../helpers/Animations'
import MediaRender from '../components/general/MediaRender'

const Quilt = styled(Flex)`
    height: 626px;
    margin-bottom: ${(props) => props.theme.space.lg};
    margin-top: ${(props) => props.theme.space.lg};
    
    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        height: 426px;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
        flex-direction: column;
        height: auto;
        margin-bottom: ${(props) => props.theme.space.md};
        margin-top: ${(props) => props.theme.space.md};
    }

    div {
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        height: 100%;
    }

    .column {
        order: 0;

        &:nth-child(1) {
            flex-basis: 65%;
            margin-right: ${(props) => props.theme.space.sm};

            @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
                flex-basis: 50%;
                margin-right: ${(props) => props.theme.space.xxs}
            }

            @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
                flex-basis: auto;
                height: 200px;
                margin-right: 0;
            }
        }

        &:nth-child(2) {
            flex-basis: 35%;
            margin-left: ${(props) => props.theme.space.sm};

            @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
                flex-basis: 50%;
                margin-left: ${(props) => props.theme.space.xxs}
            }

            @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
                flex-basis: auto;
                margin-left: 0;
                margin-top: ${(props) => props.theme.space.sm};
            }
        }
    }

    .cell {
        height: 50%;

        @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
            height: 200px;
        }

        &:nth-child(1) {
            padding-bottom: ${(props) => props.theme.space.sm};

            @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
                padding-bottom: ${(props) => props.theme.space.xxs}
            }
            @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
                padding-bottom: 0;
            }
        }
        &:nth-child(2) {
            padding-top: ${(props) => props.theme.space.sm};

            @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
                padding-top: ${(props) => props.theme.space.xxs}
            }
            @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
                margin-top: ${(props) => props.theme.space.sm};
                padding-top: 0;
            }
        }
    }
`

const GalleryQuilt = ({ options }) => {
    const config = {
        backgroundColor: 'white',
    };

    return (
        <Quilt
            alignContent="flex-start"
            bg={options.media && options.media.backgroundColor || config.backgroundColor}
            variant="container"
        >
            <Box
                alignSelf="stretch"
                className="column"
                flexGrow="1"
            >
                <AnimationWrapper type='fade-up'>
                    <MediaRender file={options.media && options.media.set[0]} options={{ backgroundImage: true }} alt={options.caption || ''} />
                </AnimationWrapper>
            </Box>
            <Box
                alignSelf="stretch"
                className="column"
                flexGrow="1"
            >
                <Box className="cell">
                    <Box>
                        <AnimationWrapper type='fade-up'>
                            <MediaRender file={options.media && options.media.set[1]} options={{ backgroundImage: true }} alt={options.caption || ''} />
                        </AnimationWrapper>
                    </Box>
                </Box>
                <Box className="cell">
                    <Box>
                        <AnimationWrapper type='fade-up'>
                            <MediaRender file={options.media && options.media.set[2]} options={{ backgroundImage: true }} alt={options.caption || ''} />
                        </AnimationWrapper>
                    </Box>
                </Box>
            </Box>
        </Quilt>
    )
}

export default GalleryQuilt
